import React from 'react'

export const Spinner = () => {
  return (
    <div className='spinner flex justify-center items-center'></div>
  )
}
